// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"259":"5a86fafe","631":"6d959d76","801":"c37b87d6"}[chunkId] + ".chunk.js";
};